import type { AiOperationTargetRef } from '../../types/aiOperational'

const targetLabel = (target: AiOperationTargetRef) =>
  target.title?.trim() || `${target.type.toLowerCase()} ${target.id.slice(0, 8)}`

export const ExecutionAffectedRecords = ({ records }: { records: AiOperationTargetRef[] }) => {
  if (!records.length) return <span className="aiExecutionAffectedRecords">Affected records not declared</span>
  return (
    <span className="aiExecutionAffectedRecords">
      {records.slice(0, 3).map(targetLabel).join(', ')}
      {records.length > 3 ? ` +${records.length - 3}` : ''}
    </span>
  )
}
